export enum ContentType {
  FormData = "multipart/form-data",
  Json = "application/json",
  Pdf = "application/pdf",
  Plain = "text/plain",
}

export class ApiResponse<T> {
  success: boolean;
  data?: T;
  status?: number;
  message?: string;
  offline?: boolean;
  totalCount?: number;
  isDeleted?: boolean;

  constructor(response: ApiResponse<T>) {
    Object.assign(this, {
      ...response,
      status: response?.status,
      success: !!response?.success,
      offline: !!response?.offline,
      isDeleted: !!response?.isDeleted,
    });
  }
}

export enum ApiMethod {
  Delete = "DELETE",
  Get = "GET",
  Patch = "PATCH",
  Post = "POST",
  Put = "PUT",
}

export enum ResponseMessage {
  Ok = "Ok",
  Accepted = "Accepted",
  Unauthorized = "Unauthorized",
  Forbidden = "Forbidden",
  NotFound = "Not Found",
  TooManyRequests = "Too Many Requests",
  InternalServerError = "Internal Server Error",
  GatewayTimeout = "Gateway Timeout",
}

export enum ResponseCode {
  Ok = 200,
  Accepted = 202,
  OkNoContent = 204,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  TooManyRequests = 429,
  InternalServerError = 500,
  GatewayTimeout = 504,
}

export const ResponseCodeKey: Record<number, ResponseMessage> = {
  200: ResponseMessage.Ok,
  202: ResponseMessage.Accepted,
  401: ResponseMessage.Unauthorized,
  403: ResponseMessage.Forbidden,
  404: ResponseMessage.NotFound,
  429: ResponseMessage.TooManyRequests,
  500: ResponseMessage.InternalServerError,
  504: ResponseMessage.GatewayTimeout,
};

export enum OfflineApiServiceKey {
  GetRequests = "getRequests",
}
